export const ACCOUNT_DETAIL_FONT_FAMILY =
  '"Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

/** Apply Inter consistently across MUI + bootstrap/reactstrap children. */
export const ACCOUNT_DETAIL_FONT_SX = {
  fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
  "& .MuiTypography-root, & .MuiButton-root, & .MuiTableCell-root, & .MuiInputBase-root, & .MuiTab-root, & .MuiChip-root, & .MuiSelect-select, & .MuiMenuItem-root, & .MuiTableSortLabel-root, & .form-control, & .btn, & label, & input, & select, & textarea":
    {
      fontFamily: "inherit",
    },
};
